import apiClient from '../../clienteFebosAPI';

const RESOURCE = '/aduanas/documentos';

export const cancelDocument = ({ documentId }) => apiClient
  .post(`${RESOURCE}/${documentId}/anular`, {}, {
    operacionId: 'aduanas.anular.documento'
  });
